const solDouyin = require("./assets/images/sol_douyin.jpg");
const solCohort = require("./assets/images/sol_cohort.jpg");
const solWebinar = require("./assets/images/sol_webinar.jpg");
const solWecom = require("./assets/images/sol_wecom.jpg");
const case01 = require("./assets/images/case_01.jpg");
const case02 = require("./assets/images/case_02.jpg");
const case03 = require("./assets/images/case_03.jpg");
const tpl01 = require("./assets/images/res_tpl_01.jpg");
const tpl02 = require("./assets/images/res_tpl_02.jpg");
const tpl03 = require("./assets/images/res_tpl_03.jpg");
const tpl04 = require("./assets/images/res_tpl_04.jpg");
const art01 = require("./assets/images/res_art_01.jpg");
const art02 = require("./assets/images/res_art_02.jpg");
const art03 = require("./assets/images/res_art_03.jpg");

export const siteData = {
  brand: {
    name: "人人讲",
    tagline: "多端售课 · 私域直播 · 客户运营",
    wechatId: "rrjdy1",
    phone: "183 9570 0692",
    email: "zhaojun@rayclear.com",
    loginUrl: "https://dy.renrenjiang.cn/#/login",
  },
  legal: {
    slogan: "人人讲·知识产品与用户服务的数字化工具",
    company: "北京云拓锐联科技有限公司",
    icp: "京ICP备11005147号-14",
    icpUrl: "https://beian.miit.gov.cn",
    publicSecurity: "京公网安备 11010702001942号",
    publicSecurityUrl:
      "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010702001942",
    publicSecurityIcon:
      "https://image.renrenjiang.cn/teacher_center/douyin/icon_website_bottom_police.png",
    sslImage:
      "https://image.renrenjiang.cn/teacher_center/douyin/icon_website_ssl.jpg",
  },
  hero: {
    kicker: "免费试用 · 专属顾问服务 · 资料中心",
    title: "打通知识付费全流程的一体化平台",
    desc: "围绕多端售课、直播转化与客户运营场景，帮助讲师与机构构建更高效的课程经营体系与用户服务体系。",
    trust: [
      "快速开通：支持课程上架与直播配置",
      "标准化交付：提供模板与运营方法库",
      "能力扩展：支持客户运营与团队协同升级",
      "开放接入：支持 OpenClaw、接口与工作流集成",
    ],
    heroImage: "https://cdn-hz.renrenjiang.cn/home/home_banner_01.jpg",
  },
  homeExperts: {
    title: "行业头部达人，都在使用人人讲",
    items: [
      {
        name: "SOU-E",
        intro:
          "流行演唱高级讲师，玄动音乐-声乐指导兼歌手，东正音乐-御用歌手，网罗新声代(广州赛区)-声乐导师",
        avatar: "https://image.renrenjiang.cn/home/home_demo_5.png",
      },
      {
        name: "宿耀文",
        intro:
          "首创简谱五线谱对照谱，让零基础学钢琴更简单，专注零基础学钢琴速成方法，20分钟即可弹奏一首钢琴曲",
        avatar: "https://image.renrenjiang.cn/home/home_demo_9.png",
      },
      {
        name: "降央卓玛",
        intro:
          "中国藏族女歌手，2005年毕业于四川音乐学院。西藏音乐家协会副主席、理事、西藏文艺志愿者协会副主席",
        avatar: "https://image.renrenjiang.cn/home/home_demo_8.png",
      },
      {
        name: "蔡仲杨",
        intro:
          "小红书摄影界头部达人，职业高级摄影师，单场活动变现突破万元，以卓越摄影技巧引领潮流，备受瞩目",
        avatar: "https://image.renrenjiang.cn/home/home_demo_1.png",
      },
      {
        name: "何卷卷",
        intro:
          "抖音声乐头部讲师，以其独特的教学方法深受学员喜爱，帮助学员解锁悦耳歌喉，唱响音乐梦想",
        avatar: "https://image.renrenjiang.cn/home/home_demo_10.png",
      },
      {
        name: "张博士解焦虑",
        intro:
          "协和医学院博士，20多年医学、心理学相关经验，牛津大学正念认知课程师资，麻省理工正念减压课程师资。",
        avatar: "https://image.renrenjiang.cn/home/home_demo_11.png",
      },
      {
        name: "苦十八",
        intro:
          "抖音沙雕动画领域头部讲师，以幽默创意著称，擅长将生活点滴融入动画，传授动画制作技巧",
        avatar: "https://image.renrenjiang.cn/home/home_demo_6.png",
      },
      {
        name: "猛男魔术师TonyChen",
        intro:
          "抖音魔术界明星讲师，融合力量与魔幻，传授魔术技巧，魔术行业的超级头部，变现天花板",
        avatar: "https://image.renrenjiang.cn/home/home_demo_7.png",
      },
      {
        name: "阿豪象棋",
        intro:
          "抖音象棋领域顶尖达人，棋艺精湛，以独特视角解读棋局，分享象棋智慧，引领棋友共赏国粹之美",
        avatar: "https://image.renrenjiang.cn/home/home_demo_2.png",
      },
      {
        name: "迈索尔优+瑜伽",
        intro:
          "专注教学数年，助力学员实现身心平衡。以专业引领，探索和谐身心之道，深受学员信赖与好评",
        avatar: "https://image.renrenjiang.cn/home/home_demo_4.png",
      },
      {
        name: "艺生欧巴的声乐课",
        intro:
          "抖音声乐教学超级头部，分享专业技巧，传授发声秘籍，让每个人都能唱出动人歌声，点亮音乐梦想",
        avatar:
          "https://image.renrenjiang.cn/uploads/user/avatar_url/4529351/2021_e2472e9cee2be9510f47a9797972f3d4.png",
      },
      {
        name: "张Sir教你升职加薪",
        intro:
          "职场教学头部达人，主导企业三年四倍速业绩增长，十年企业经营管理经验沉淀!",
        avatar: "https://image.renrenjiang.cn/home/home_demo_3.png",
      },
    ],
  },
  homeRAndD: {
    title: "强大的研发实力，安全稳定可靠的系统支持",
    desc: "来自互联网优秀的技术研发团队, 打造安全稳定可用的系统",
    image:
      "https://image.renrenjiang.cn/domain_tools/website/icon_website_system_image.png",
  },
  homeTrial: {
    title: "人人讲致力于为讲师提供稳定、清晰、可持续的课程售卖能力",
    buttonText: "立即试用",
    background:
      "https://image.renrenjiang.cn/domain_tools/website/icon_website_try_bg.jpg",
  },
  homeService: {
    title: "服务与支持",
    subtitle: "全流程运营与售后保障",
    items: [
      {
        title: "上架协助",
        desc: "入驻与课程上架全流程协助",
        icon: "https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_serve_3.png",
      },
      {
        title: "政策指导",
        desc: "合规审核与规则变动提醒",
        icon: "https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_serve_2.png",
      },
      {
        title: "售后客服",
        desc: "售后与学员问题快速响应",
        icon: "https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_serve_1.png",
      },
    ],
  },
  modules: [
    {
      key: "course-commerce",
      badge: "核心模块",
      title: "多端售课",
      desc: "面向讲师与机构的基础经营场景，支持课程发布、交易转化与内容交付闭环。",
      image: "https://cdn-hz.renrenjiang.cn/home/new/site_product_multiple.jpg",
      bullets: [
        "提供品牌自有店铺，覆盖上架、销售、交付、售后全链路",
        "支持课程、专栏、训练营、会员等内容形态",
        "支持 H5、小程序、PC 等多端承接",
        "提供订单、支付、优惠与基础营销能力",
        "支持进度管理、作业打卡与资料下载交付",
      ],
    },
    {
      key: "private-live",
      badge: "增长模块",
      title: "私域直播",
      desc: "围绕公开课、说明会与转化直播场景，提升直播组织效率与转化效率。",
      image: "https://cdn-hz.renrenjiang.cn/home/new/site_product_live.jpg",
      bullets: [
        "提供直播中控台，支持控场、商品上架与优惠配置",
        "支持互动组件与私域承接链路配置",
        "提供实时数据看板，辅助关注热度与转化效果",
        "支持直播复盘模板与后续行动建议沉淀",
      ],
    },
    {
      key: "scrm",
      badge: "专业模块",
      title: "专业SCRM",
      desc: "面向规模化运营团队，支持客户分配、过程质检与经营归因分析。",
      image: "https://cdn-hz.renrenjiang.cn/home/new/site_product_scrm.jpg",
      bullets: [
        "支持按负载、标签与保护期进行线索分配",
        "支持多企微账号控频分流与策略管理",
        "支持会话质检、风险提醒与话术规范管理",
        "支持按员工、场次与渠道进行ROI拆解分析",
      ],
    },
  ],
  openclaw: {
    key: "openclaw",
    badge: "开放能力",
    title: "OpenClaw 开放接入",
    desc: "连接人人讲与业务系统，打通课程经营、直播转化、客户承接与数据回流。",
    image: "https://image.renrenjiang.cn/home/skills_shrimp.png",
    bullets: [
      "支持开放接口、事件触发与工作流编排",
      "支持课程、订单、直播、用户等核心数据联动",
      "支持自动化通知、分配、交付与回传场景",
      "适用于需要系统集成与流程自动化的团队",
    ],
    heroNote:
      "面向知识付费业务的开放接入能力，帮助团队把关键业务动作沉淀为稳定、可复用的自动化流程。",
    features: [
      {
        title: "课程与专栏",
        desc: "同步课程、专栏、训练营等内容形态，联动价格、库存、上下架状态。",
      },
      {
        title: "订单与支付",
        desc: "联动订单、支付、退款与优惠信息，支撑财务对账与客服协同处理。",
      },
      {
        title: "直播与活动",
        desc: "打通直播场次、预约、观看、成交等关键节点数据，辅助过程监控与复盘。",
      },
      {
        title: "用户与企微",
        desc: "连接报名用户、标签、顾问承接与客户分配策略，提升私域承接效率。",
      },
      {
        title: "自动化流程",
        desc: "围绕开课、交付、提醒、转化等环节配置自动执行动作，降低人工重复操作。",
      },
      {
        title: "经营分析",
        desc: "按课程、场次、顾问、渠道汇总关键经营数据，构建统一业务视图。",
      },
    ],
    scenarios: [
      {
        title: "课程经营",
        desc: "同步今日新增课程、价格变动与上下架状态到内部商品中心，保持多系统信息一致。",
      },
      {
        title: "直播转化",
        desc: "直播结束后自动回传到场、下单、未转化名单，并生成后续跟进任务。",
      },
      {
        title: "私域承接",
        desc: "根据渠道、意向标签与团队配置，自动把报名用户分配给对应企微顾问。",
      },
      {
        title: "交付协同",
        desc: "成交后自动开通课程、发送资料、创建打卡任务，提升交付效率与一致性。",
      },
      {
        title: "财务对账",
        desc: "同步订单、退款、优惠与支付明细，生成每日对账报表并支持异常排查。",
      },
      {
        title: "管理分析",
        desc: "按课程、场次、顾问维度汇总转化结果，辅助经营复盘与管理决策。",
      },
    ],
    setupSteps: [
      {
        step: "Step 01",
        title: "确认业务目标",
        desc: "梳理需要接入的业务系统、核心场景与预期结果，明确本期对接范围。",
      },
      {
        step: "Step 02",
        title: "准备接口信息",
        desc: "开通 OpenClaw 接入能力，并准备 API、字段映射、回调地址与权限配置。",
      },
      {
        step: "Step 03",
        title: "配置流程与事件",
        desc: "围绕课程、订单、直播、用户等关键节点配置触发规则与自动化动作。",
      },
      {
        step: "Step 04",
        title: "联调与上线",
        desc: "完成验证、回传测试与灰度上线，确保业务数据流转稳定可用。",
      },
    ],
  },
  solutions: [
    {
      key: "douyin-to-private",
      title: "抖店获客转化",
      desc: "围绕公域获客、私域承接与直播转化，构建更完整的二次成交路径。",
      forWho: "抖店引流课程团队与训练营团队",
      steps: [
        "抖店订单同步",
        "短信/企微承接",
        "直播中控台转化",
        "48小时跟进",
        "ROI复盘",
      ],
      recommend: "推荐使用专业版，并结合资源包与专业运营服务进行配置",
      cover: solDouyin,
    },
    {
      key: "cohort-and-retention",
      title: "训练营交付与复购",
      desc: "通过阶段化交付、助教协同与直播串联，提升交付质量与复购转化。",
      forWho: "训练营、陪跑型服务与会员订阅团队",
      steps: [
        "训练营上架",
        "阶段任务与打卡",
        "直播答疑",
        "结营转化",
        "复购与转介绍",
      ],
      recommend: "可根据团队规模与交付复杂度选择标准版或专业版",
      cover: solCohort,
    },
    {
      key: "live-conversion",
      title: "直播公开课转化",
      desc: "围绕公开课、说明会与体验课场景，优化直播节奏、内容承接与转化动作。",
      forWho: "开展公开课、说明会与体验课的讲师及机构",
      steps: [
        "预热与邀看",
        "直播控场节奏",
        "优惠与上架",
        "看播分层",
        "二转跟进",
      ],
      recommend: "推荐使用专业版，规模化团队可进一步升级旗舰版",
      cover: solWebinar,
    },
    {
      key: "wecom-ops",
      title: "多团队企微承接",
      desc: "面向多员工、多账号协同场景，提升线索流转效率与过程规范性。",
      forWho: "多员工、多企微账号的转化团队",
      steps: [
        "线索分配",
        "控频分流",
        "质检抽检",
        "训练与纠偏",
        "ROI按员工拆解",
      ],
      recommend: "建议使用旗舰版，并结合专业客户运营能力进行配置",
      cover: solWecom,
    },
  ],
  customers: [
    {
      id: "case-edu-01",
      title: "职业技能机构：公开课转化流程标准化升级",
      industry: "职场/考证",
      team: "8人二转团队",
      used: ["多端卖课", "私域直播"],
      result: "到场率提升 20%–35%，二转成交率提升 10%–18%",
      cover: case01,
      story: [
        "上线前：订单承接慢、直播节奏不稳定、复盘难沉淀。",
        "上线后：固定直播脚本 + 中控台动作清单 + 48小时跟进SOP。",
        "结果：关键指标持续提升，并形成可复用模板。",
      ],
    },
    {
      id: "case-edu-02",
      title: "心理成长讲师：训练营交付带动复购增长",
      industry: "心理/成长",
      team: "2人小团队",
      used: ["多端卖课"],
      result: "训练营完成率提升 15%–25%，复购率提升 8%–12%",
      cover: case02,
      story: [
        "上线前：交付动作分散，用户体验不一致。",
        "上线后：阶段交付 + 打卡作业 + 直播答疑串联。",
        "结果：体验更稳定，复购更容易发生。",
      ],
    },
    {
      id: "case-edu-03",
      title: "电商培训团队：多账号控频分流提升团队人效",
      industry: "电商培训",
      team: "18人团队",
      used: ["多端卖课", "私域直播", "SCRM"],
      result: "漏接率下降，响应效率提升，经营结果可按员工维度追溯",
      cover: case03,
      story: [
        "上线前：多账号多员工容易撞单/漏跟。",
        "上线后：控频分流策略 + 策略日志 + 质检抽检。",
        "结果：团队承接更稳，管理更清晰。",
      ],
    },
  ],
  pricing: {
    plans: [
      {
        key: "starter",
        name: "标准版",
        badge: "零门槛",
        price: "免费",
        unit: "",
        desc: "多端卖课 + 私域基础直播",
        highlights: [
          "抖音、视频号、小红书、快手卖课",
          "私域基础直播能力",
          "多端数据经营看板",
          "存储、宽带资源按量",
        ],
      },
      {
        key: "growth",
        name: "私域增强版",
        badge: "强运营",
        price: "¥5688",
        unit: "/ 年",
        desc: "适用于公私域协同、有私域学员维护需求的团队与个体讲师",
        highlights: [
          "更强的私域直播能力",
          "直播中控台与数据复盘模板",
          "解锁多人管理权限",
          "支持专业能力扩展",
        ],
        featured: true,
      },
      {
        key: "pro",
        name: "团队SCRM版",
        badge: "规模化",
        price: "¥9688",
        unit: "/ 年",
        desc: "适用于规模化经营、多人销售团队协同场景",
        highlights: [
          "公转私引流链路",
          "私域SCRM能力",
          "全链路客户追踪能力",
          "支持专业能力扩展",
        ],
      },
    ],
    addons: [
      {
        title: "SCRM专业包",
        desc: "支持控频分流、会话质检、公海保护期与更深层经营归因",
      },
      {
        title: "资源包（按量）",
        desc: "适用于短信、存储与直播接量等资源场景，计费标准以实际商务方案为准",
      },
    ],
    faq: [
      {
        q: "试用会包含哪些功能？",
        a: "试用期默认开放售课与直播相关核心能力，专业客户运营能力可根据业务需求申请演示开通。",
      },
      {
        q: "是否支持加微信获取资料与试用辅导？",
        a: "支持。注册试用后可添加顾问微信，获取上手清单、演示视频与试用指导服务。",
      },
      {
        q: "老客户升级如何兼容历史资源成本？",
        a: "支持平滑升级与资源抵扣等配套方案，具体以实际商务政策与合同约定为准。",
      },
    ],
  },
  resources: {
    templates: [
      {
        id: "tpl-001",
        title: "卖课上手3步清单",
        type: "模板",
        tag: "卖课",
        cover: tpl01,
      },
      {
        id: "tpl-002",
        title: "直播中控台Checklist",
        type: "模板",
        tag: "直播",
        cover: tpl02,
      },
      {
        id: "tpl-003",
        title: "直播复盘模板（数据→问题→动作）",
        type: "模板",
        tag: "复盘",
        cover: tpl03,
      },
      {
        id: "tpl-004",
        title: "ROI周报模板（按员工/场次/渠道）",
        type: "模板",
        tag: "ROI",
        cover: tpl04,
      },
    ],
    articles: [
      {
        id: "art-001",
        title: "低价课到高价课：二转漏斗的4个断点与解法",
        date: "2026-06-10",
        tag: "方法论",
        cover: art01,
        excerpt: "围绕获客、承接、直播与跟进，建立标准化转化路径与复盘机制。",
        content:
          "低价引流课程的核心价值，在于建立稳定的用户承接与转化路径。围绕渠道引流、企业微信承接、直播成交与后续跟进，统一数据口径和执行标准，能够显著提升团队经营效率。\n\n建议从线索承接效率、直播转化节奏、跟进时效与复盘机制四个方面同步优化，逐步形成标准化运营体系。",
      },
      {
        id: "art-002",
        title: "直播不是讲完就算：复盘如何决定下一场的增长",
        date: "2026-06-08",
        tag: "直播",
        cover: art02,
        excerpt:
          "通过结构化复盘与行动清单，持续提升直播经营的稳定性与可复制性。",
        content:
          "直播复盘并非简单回顾数据，而是围绕关键节点、用户反馈、转化动作与后续跟进进行系统分析。通过统一模板记录问题、结论与改进动作，可以帮助团队快速沉淀方法论。\n\n对直播团队而言，复盘机制越清晰，后续排期、脚本与运营协同就越高效。",
      },
      {
        id: "art-003",
        title: "什么时候你才需要SCRM？一张判断表",
        date: "2026-06-05",
        tag: "SCRM",
        cover: art03,
        excerpt:
          "当团队协同、线索分配与过程管理要求提升时，专业客户运营能力将发挥更大价值。",
        content:
          "专业客户运营能力适用于线索规模扩大、账号协同增多与过程管理要求提升的经营阶段。通过线索分配、控频分流、会话质检与经营分析，能够更好地保障业务秩序与团队效率。\n\n建议结合团队规模、业务复杂度与管理要求，分阶段推进能力升级。",
      },
    ],
    updates: [
      {
        id: "upd-001",
        title: "直播中控台新增“场景切换与关键节点提醒”",
        date: "2026-06-07",
      },
      {
        id: "upd-002",
        title: "价格体系更新：三档版本与专业能力扩展方案同步发布",
        date: "2026-06-06",
      },
      {
        id: "upd-003",
        title: "资源中心上线：模板下载与公开课报名",
        date: "2026-06-05",
      },
    ],
    webinars: [
      {
        id: "web-001",
        title: "产品应用课：完成首场课程经营与直播配置",
        date: "本周四 19:30",
        speaker: "人人讲产品顾问",
      },
      {
        id: "web-002",
        title: "增长课：公开课转化脚本与中控台实战",
        date: "下周二 19:30",
        speaker: "人人讲客户成功",
      },
    ],
  },
  services: {
    onboarding: {
      title: "试用指导服务（7天）",
      desc: "注册试用后可添加顾问微信，按里程碑完成课程上架、直播配置与经营复盘。",
      steps: [
        { day: "第1天", do: "开店/上架/支付设置", out: "完成首个课程上架" },
        { day: "第3天", do: "直播预热与邀看SOP", out: "完成首场公开课配置" },
        {
          day: "第7天",
          do: "复盘模板 + 48小时跟进SOP",
          out: "产出复盘与下一场行动清单",
        },
      ],
    },
    success: {
      title: "客户成功",
      desc: "面向规模化团队提供标杆共创、方法沉淀与持续增长支持。",
      items: [
        "标杆案例共创",
        "增长诊断与方案",
        "团队训练与质检",
        "数据口径与ROI体系",
      ],
    },
  },
};

export function getProductByKey(key) {
  return (
    siteData.modules.find((item) => item.key === key) ||
    (key === "openclaw" ? siteData.openclaw : null)
  );
}
